// libs
import React, { memo } from 'react';

// components
import MobileCarousel from 'shared/layouts/DetailsPage/components/Widgets/components/MobileCarousel';

interface IResponsiveCAV {
  products: Listing.IProduct[];
  widgetMetaData: Record<string, any>;
  isCAV: boolean;
}

function RenderMobileCAV({ products, widgetMetaData }: IResponsiveCAV) {
  return <MobileCarousel products={products} isCAV widgetMetaData={widgetMetaData} />;
}

export default memo(RenderMobileCAV);
